import {ApiCollection} from "./api.collection";
import {StateCounty} from "../models/state-county.model";


export const StateCounties = ApiCollection.extend({
    model: StateCounty,
    url: 'api/state-counties',
});
